module.exports = __webpack_public_path__ + "img/product-list_m1.01afa32e.png";